import InstitutionKycCddForm from '@/features/institution/kyc-cdd/components/form';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingKycCddPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="kycCdd" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionKycCddForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingKycCddPage.displayName = 'InstitutionOnboardingKycCddPage';

export default InstitutionOnboardingKycCddPage;
